// Mapping des champs de tri vers les valeurs de l'enum API FilteredEmployeeOrderBy
export const EMPLOYEE_ORDER_BY = {
	None: 0,
	FirstName: 1,
	LastName: 2,
	Role: 3,
	WFY: 4, // WorkFamily
	WFU: 5, // WorkFunction
	Site: 6,
	GroupsOfUser: 7,
};

// Mapping des noms de champs de colonnes vers les valeurs de l'API
export const FIELD_TO_ORDER_BY = {
	FirstName: EMPLOYEE_ORDER_BY.FirstName,
	LastName: EMPLOYEE_ORDER_BY.LastName,
	Role: EMPLOYEE_ORDER_BY.Role,
	WorkFamillyId: EMPLOYEE_ORDER_BY.WFY,
	WorkFunctionId: EMPLOYEE_ORDER_BY.WFU,
	SiteId: EMPLOYEE_ORDER_BY.Site,
	groups: EMPLOYEE_ORDER_BY.GroupsOfUser,
};

// Mapping de la direction de tri
export const ORDER_DIRECTION = {
	asc: 0, // Ascending
	desc: 1, // Descending
};

/**
 * Convertit les paramètres de tri MaterialTable vers les valeurs API
 * @param {string} field - Nom du champ à trier
 * @param {string} direction - Direction "asc" ou "desc"
 * @returns {Object} { orderBy: number, orderDirection: number }
 */
export const convertSortParams = (field, direction) => {
	const orderBy = FIELD_TO_ORDER_BY[field] ?? EMPLOYEE_ORDER_BY.None;
	const orderDirection = ORDER_DIRECTION[direction] ?? ORDER_DIRECTION.asc;

	return { orderBy, orderDirection };
};
